// src/components/HLVOutput.js
import React, { useEffect, useState } from "react";
import { Pie, Bar, Doughnut, Line } from "react-chartjs-2";
import { ArcElement } from "chart.js";
import Chart from "chart.js/auto"; // Import Chart as well
import useHLVOutput from "./useHLVOutput";

Chart.register(ArcElement);

const HLVOutput = ({ user }) => {
  const {
    humanLifeValue,
    incomeBarChartData,
    options,
    incomeDoughnutData,
    savingsPercentage,
    incomeSavingsData,
    fiftyPercentOfSaving,
  } = useHLVOutput(user);
  console.log("user: ", user);

  return (
    <div className="max-w-3xl mx-auto py-6 lg:px-16 px-6 bg-slate-100 border-2 rounded-md my-4 ">
      {/* <h1 className="text-center text-4xl font-medium mb-6">HLV Information</h1> */}

      <div className="text-xl md:text-4xl lg:text-4xl font-medium mt-4 mb-6 w-full text-center">
        <span className="text-blue-400 font-semibold">
          Welcome {user.fullName}
        </span>
      </div>

      <div className="text-xl font-medium my-4">
        <span className="font-semibold">
          Thank you for giving us the opportunity to serve you and taking the
          time to fill in our questionnaire.
        </span>{" "}
        Human life value is the amount of money your family would require, in
        case of your untimely death, to continue to live their lives as you
        would have wanted them, and not compromise on their future goals.
      </div>
      <div className="text-2xl font-medium my-4 w-full text-center">
        <span className="text-blue-400 font-semibold">
          Your Human Life Value is{" "}
        </span>
        {humanLifeValue}.
      </div>
      <div className="flex flex-col lg:flex-row md:flex-row gap-3 justify-center mb-8">
        <div className="bg-gradient-to-tr from-blue-500 to-green-500 p-2 pb-3 text-white rounded-md w-full h-20 text-lg text-center mb-2">
          <p className="mb-1">Total Income</p>
          <p>
            <b className="rupee_symp mr-1 text-white">&#8377;</b>
            {user?.monthlyIncome * 12}
          </p>
        </div>
        <div className="bg-gradient-to-tr from-blue-500 to-green-500 p-2 pb-3 text-white rounded-md w-full  h-20 text-lg text-center">
          <p className="mb-1">Total Expense</p>
          <p>
            <b className="rupee_symp mr-1 text-white">&#8377;</b>
            {user?.monthlyExpenses * 12}
          </p>
        </div>
      </div>

      <h2 className="text-2xl font-bold mb-2 w-full text-center">
        Income/Expenses Distribution
      </h2>

      <div className="flex flex-col gap-4 my-4">
        <div className="flex justify-center lg:h-80 md:h-80 w-full my-4">
          <Bar
            data={incomeBarChartData}
            options={{
              scales: {
                y: {
                  beginAtZero: true,
                },
              },
            }}
          />
        </div>

        <div className="lg:h-96 md:h-96 w-full flex justify-center items-center my-4">
          <Doughnut data={incomeDoughnutData} options={options} />
        </div>
      </div>
      <h2 className="text-2xl font-bold my-4 w-full text-center">
        Savings as Percent of Income
      </h2>
      <div className="flex flex-col gap-4 ">
        <div className="w-full ">
          <p>
            Based on your monthly income, you are saving{" "}
            <span className="text-blue-400 font-semibold">
              {savingsPercentage.toFixed(2)}%
            </span>{" "}
            of your income.
            <p>
              {savingsPercentage.toFixed(2) >= 15 ? (
                <>
                  <span className="font-bold">Congratulations</span>. You are on
                  the right track. Keep it up, To achieve your Life Goals that
                  involve Protection for your family and yourself,{" "}
                </>
              ) : (
                <>
                  To further enhance your financial security, consider
                  increasing your savings to at least 15% of your Income. This
                  will help you achieve your Life Goals that involve Protection
                  for your family and yourself.{" "}
                </>
              )}
              <span className="font-bold">Insurance</span> is the most suitable
              option and ensure that a minimum of{" "}
              <span className="font-bold">50%</span> of your savings or{" "}
              <span className="text-blue-400 font-semibold">
                ₹ {fiftyPercentOfSaving}
              </span>{" "}
              is always kept aside for your and your family’s future needs.
            </p>
          </p>
        </div>

        <div className="lg:h-96 md:h-96 w-full flex justify-center items-center">
          <Doughnut data={incomeSavingsData} options={options} />
        </div>
      </div>
    </div>
  );
};

export default HLVOutput;
